import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function G() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2max.detail');

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.d2x-detail-G .point1', { y: 50 }, { y: 0 }, 0.6],
                ['.d2x-detail-G .point2', { y: 100 }, { y: 0 }, 1.2],
                ['.d2x-detail-G .point3', { y: 150 }, { y: 0 }, 1.8],
            ],
            asyncTimeLine: [0, 0, 0],
            triggerElement: '.d2x-detail-G .point-box',
            triggerHook: 1,
            offset: 0,
            duration: '20%',
        });
    }, []);
    return (
        <div
            className={`d2x-detail-G ${css.d2xDetailG} GtmModuleData-section`}
            id="d2x-detail-G"
            data-section-id={'d2x-detail-G'}
            data-section-title={t('sec7_title')}
        >
            <div className="text-box">
                <div className="slogan">{t('sec7_slogan')}</div>
                <div className="title">{t('sec7_title')}</div>
                <div className="img-box">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zf.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/zf.jpg')}
                        alt={t('sec7_title')}
                        aria-label={t('sec7_title')}
                    />
                </div>
                <div className="desc">{t('sec7_desc')}</div>
            </div>
            <div className="point-box">
                <div className="point point1">
                    <div className="text1">{t('sec7_point1_text1')}</div>
                    <div className="text2">{t('sec7_point1_text2')}</div>
                </div>
                <div className="point point2">
                    <div className="text1">{t('sec7_point2_text1')}</div>
                    <div className="text2">{t('sec7_point2_text2')}</div>
                </div>
                <div className="point point3">
                    <div className="text1">{t('sec7_point3_text1')}</div>
                    <div className="text2">{t('sec7_point3_text2')}</div>
                </div>
            </div>
        </div>
    );
}
